import interpolate from '@/lib/interpolate';
import { parseA11yLabels, reportMissingLabels } from '@/lib/a11y_labels';

const container = document.querySelector('.js-articles-list');
const articles = container.querySelector('ul');
const nav = container.querySelector('[data-articles-nav]');
const statusEl = container.querySelector('[data-articles-status]');
const labels = parseA11yLabels(nav?.dataset || {}, 'articles_list');

// The pack ships with the list, the paginator only from six articles on: below that
// there is no nav, hence no labels to miss.
if (nav) reportMissingLabels(labels, ['status', 'empty'], 'articles_list');

const paginators = document.querySelectorAll('.paginator-advice');
const ul = Array.from(articles.querySelectorAll('.js-article'));

paginators.forEach(paginator => {
  paginator.addEventListener('click', () => {
    const min = parseInt(paginator.dataset.offset, 10);
    const max = min + 5;
    ul.forEach((article, index) => {
      if (index >= min && index <= max) {
        article.classList.remove('hidden');
      } else {
        article.classList.add('hidden');
      }
    });

    paginators.forEach(p => {
      p.removeAttribute('aria-current');
      p.classList.remove('underline');
    });
    paginator.setAttribute('aria-current', 'page');
    paginator.classList.add('underline');

    if (statusEl) {
      // The button count is fixed while the article count is not: the last pages can
      // hold nothing at all, and an unbounded range reads backwards.
      const from = Math.min(min, ul.length);
      const to = Math.min(max + 1, ul.length);

      statusEl.textContent =
        from < to
          ? interpolate(labels.status, { first: from + 1, last: to })
          : labels.empty;
    }
  });
});
